import React from "react";
import { Modal } from "react-bootstrap";
import ExplorecabPage from "../../explorecab/components/ExplorecabPage";
import "../../explorecab/components/ExplorecabPage.css";
import "../../../home/components/HomePage.css";
import close_cross from "../../../../assets/close_cross.svg";
import { connect } from "react-redux";
import { maintainModify } from "../../../home/redux/actions";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

function Modifypopup(props) {
  const navigate = useNavigate();
  const closePopup = () => {
    if(!props?.destination?.kilometer || props?.destination?.kilometer <=0 ){
      navigate("../")
    }else{
      props?.callBackList()
    }
    props?.maintainModify(false);

  };

  return (
    <Modal show={props?.showmodify} size="xl" centered>
      <Modal.Body>
        <img
          src={close_cross}
          style={{ right: "-10px", top: "-10px", backgroundColor: "white" }}
          alt="search"
          className="close-icon"
          onClick={() => closePopup()}
        />
        <ExplorecabPage callBackList={props?.callBackList} ></ExplorecabPage>
      </Modal.Body>
    </Modal>
  );
}
Modifypopup.propTypes = {
  callBackList: PropTypes.func
}
Modifypopup.defaultProps = {
  callBackList: ()=>{}
}

const mapStateToProps = (state) => ({
  showmodify: state?.home?.showmodify,
  destination: state?.home?.destination,
});

export default connect(mapStateToProps, { maintainModify })(Modifypopup);
